export const ENTITY = 'FAQ';